import React, { useState, useEffect, useRef, useMemo, useLayoutEffect } from 'react';
import { IoPrintOutline } from "react-icons/io5";
import axios from 'axios';
import Swal from 'sweetalert2';
import Ecobank from '../../../Assets/providus.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToWords } from 'to-words';

export default function DefaultCheque() {
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [chequeLoading, setChequeLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [bearer, setBearer] = useState('');
  const [description, setDescription] = useState('');
  const [beneficiary1, setBeneficiary1] = useState('');
  const [beneficiary, setBeneficiary] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState("");
  const printRef = useRef();

  const [printed, setPrinted] = useState(false);
  const [totalNetPayInWords, setTotalNetPayInWords] = useState('');
  const [size, setSize] = useState('');
  const location = useLocation();

  // State to track if the text has wrapped to multiple lines
  const [isWrapped, setIsWrapped] = useState(false);
  // Ref hooked directly to the "The sum of" text element
  const sumOfLabelValueRef = useRef(null);

  const rawInvoice = location.state?.invoice;
  const invoices = Array.isArray(rawInvoice) ? rawInvoice : rawInvoice ? [rawInvoice] : [];
  console.log(invoices);

  const toWords = new ToWords({
    localeCode: 'en-US',
    converterOptions: {
      currency: true,
      currencyOptions: {
        name: invoices[0]?.currency?.currency || "Naira",
        plural: invoices[0]?.currency?.currency || "Naira",
        symbol: invoices[0]?.currency?.symbol || "₦",
        fractionalUnit: {
          name: invoices[0]?.currency?.fraction || "kobo",
          plural: invoices[0]?.currency?.fraction || "kobo",
          symbol: invoices[0]?.currency?.symbol || "k",
        },
      },
    },
  });

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const size = await localStorage.getItem('chequeSize');

      if (value !== null) setBearer(value);
      if (size !== null) setSize(size);
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => { readData(); }, []);

  // Check wrap state after render or when text content changes
  useLayoutEffect(() => {
    if (sumOfLabelValueRef.current) {
      const element = sumOfLabelValueRef.current;
      
      // Determine line height to calculate lines
      const computedStyle = window.getComputedStyle(element);
      let lineHeight = parseFloat(computedStyle.lineHeight);
      
      // Fallback calculation if line-height returns "normal"
      if (isNaN(lineHeight)) {
        lineHeight = parseFloat(computedStyle.fontSize) * 1.2; 
      }

      const clientHeight = element.clientHeight;
      const hasWrapped = clientHeight > lineHeight * 1.5; // True if more than 1 line height

      setIsWrapped(hasWrapped);
      console.log(`[Cheque Layout] Text Wrapped Status: ${hasWrapped} (Height: ${clientHeight}px, LineHeight: ${lineHeight}px)`);
    }
  }, [invoices]);

  const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${bearer}` };
  const handlePrint = () => { window.print(); };

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = String(today.getFullYear());
  const formattedDate = `${day}-${month}-${year}`;
  const dateDigits = formattedDate.split("");

  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      backgroundColor: '#f0f0e9ff',
      height: '100vh'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 672,
      marginBottom: 20,
      padding: '0 20px',
    },
    headerTitle: { margin: 0, fontSize: 24, color: '#2c3e50', marginTop: 20 },
    icon: { fontSize: 28, cursor: 'pointer', color: '#2c3e50', transition: 'color 0.3s ease' },
    chequeWrapper: { marginBottom: 60 },
    cheque: {
      width: 672,
      height: 301.44,
      padding: '10px 20px',
      border: 'none',
      position: 'relative',
      backgroundColor: '#f9f8deff',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    topRow: { display: 'flex', justifyContent: 'space-between', marginTop: 0, padding: 0 },
    chequeNumber: { display: 'flex', justifyContent: 'flex-end', margin: 0, paddingTop: 5, fontSize: 12, color: '#2c3e50' },
    dateBox: { display: 'flex', justifyContent: 'flex-end', marginTop: 30, gap: 4 },
    section: { position: 'relative', display: 'flex', alignItems: 'center', gap: 0 },
    dateLabel: { position: 'absolute', top: -20, left: '50%', transform: 'translateX(-50%)', fontSize: 12 },
    digitBox: {
      width: 28.8, height: 38.4, border: 'none', margin: '0 2px', textAlign: 'center', lineHeight: '18.9px',
      fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', color: '#2c3e50',
    },
    payTo: { display: 'flex', alignItems: 'center', gap: 4, marginTop: 10, position: 'relative' },
    sumOf: { display: 'flex', alignItems: 'center', gap: 4, position: 'relative' },
    payToLabel: { fontSize: 11, textAlign: 'right', width: 70, color: '#2c3e50' },
    sumOfLabel: { fontSize: 11, textAlign: 'right', width: 70, color: '#2c3e50' },
    payToValue: {  fontWeight: 'bold', fontSize: 16 },
    sumOfLabelValue: {  
      fontWeight: 'bold', 
      fontSize: 16,
      width: '700px',            // Fixed screen width constraint as specified
      wordBreak: 'break-word',   // Ensure strings split cleanly onto lines if long
      whiteSpace: 'normal'
    },
    amountBox: { display: 'flex', justifyContent: 'flex-end', marginTop: 10, gap: 4 },
    amountPrefix: { fontSize: 14, lineHeight: '30.24px', color: '#2c3e50' },
    inputBox: {
      width: 196.56, height: 30.24, border: 'none', textAlign: 'left', fontSize: 16, lineHeight: '30.24px',
      paddingLeft: 10, boxSizing: 'border-box', backgroundColor: '#fff', fontWeight: 'bold',
    },
    accountDetails: { fontSize: 12, color: '#2c3e50', position: 'absolute', bottom: 16, left: 20 },
  };

  const extractWidth = (size) => {
    if (!size || size.trim() === "") return 0;
    const match = size.match(/^([\d.]+)cm/);
    return match ? parseFloat(match[1]) : 0;
  };

  const height = extractWidth(size);
  const adjustment = height && height >= 10 ? 0.1 : 0;

  // Dynamically compute layout print properties based on screen wrapped state
  const printCSS = useMemo(() => `
@media print {
  @page { size: 29.7cm 21cm; margin: 0; }

  [data-role="container"] {
    background: none !important;
    box-shadow: none !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    padding: 0 !important;
  }

  [data-role="header"] { display: none !important; visibility: hidden !important; }

  [data-role="cheque"] {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    page-break-after: always !important;
    break-after: page !important;
    position: relative !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  [data-role="cheque"]:last-child { page-break-after: auto !important; break-after: auto !important; }

  [data-role="cheque"] * {
    display: none !important;
    visibility: hidden !important;
  }

  [data-role="cheque"] [data-role="payToValue"] {
    display: block !important;
    visibility: visible !important;
    border: none !important;
    background: none !important;
    text-align: left !important;
    margin-left: 17cm !important;
    margin-top: 0.13cm !important;
    white-space: nowrap !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 20px !important;
  }

  [data-role="cheque"] [data-role="sumOfLabelValue"] {
    display: block !important;
    visibility: visible !important;
    border: none !important;
    background: none !important;
    text-align: left !important;
    margin-left: 17cm !important;
    margin-top: -0.17cm !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 18px !important;
    white-space: normal !important;
    width: 700px !important;  
    padding-right: 5px !important;        /* Keeps identical 300px width target in print */
  }

  [data-role="cheque"] [data-role="payTo"] { display: block !important; visibility: visible !important; }
  [data-role="cheque"] [data-role="payToLabel"] { display: none !important; visibility: hidden !important; }
  [data-role="cheque"] [data-role="sumOf"] { display: block !important; visibility: visible !important; }

  [data-role="cheque"] [data-role="topRow"] {
    display: flex !important; visibility: visible !important; color: black !important; border: none !important; background: none !important;
  }

  [data-role="cheque"] [data-role="dateBox"] {
    display: flex !important;
    flex-direction: row !important;
    justify-content: flex-end !important;
    align-items: flex-start !important;
    visibility: visible !important;
    background: none !important;
    border: none !important;
    margin-left: 28cm !important;
    margin-top: 4.8cm !important;
    color: black !important;
    gap: 0 !important;
  }

  [data-role="cheque"] [data-role="section"]:nth-child(1) { margin-right: 1rem !important; }
  [data-role="cheque"] [data-role="section"]:nth-child(2) { margin-right: 1rem !important; }
  [data-role="cheque"] [data-role="section"]:nth-child(3) { margin-right: 0 !important; }

  [data-role="cheque"] [data-role="digitBox"] {
    margin: 0 0.1rem !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    background: none !important;
    color: black !important;
    border: none !important;
    width: 28px !important;
    height: 38px !important;
  }

  [data-role="cheque"] [data-role="section"]:nth-child(1) .digitBox { transform: translateY(0); }
  [data-role="cheque"] [data-role="section"]:nth-child(2) .digitBox { transform: translateY(0.2rem); }
  [data-role="cheque"] [data-role="section"]:nth-child(3) .digitBox { transform: translateY(-0.1rem); }

  [data-role="cheque"] [data-role="section"] { margin-right: -1px !important; }
  [data-role="cheque"] [data-role="digitBox"] { margin: 0 -4px !important; }
  [data-role="cheque"] [data-role="section"]:first-child { margin-right: 5px !important; }
  [data-role="cheque"] [data-role="section"]:nth-child(2) { margin-right: 10px !important; }
  [data-role="cheque"] [data-role="section"]:last-child { margin-right: 0 !important; }

  [data-role="cheque"] [data-role="dateBox"] * {
    display: flex !important; visibility: visible !important; color: black !important; border: none !important; background: none !important;
  }
  [data-role="cheque"] [data-role="dateLabel"] { display: none !important; visibility: hidden !important; }

  [data-role="cheque"] [data-role="amountBox"] { display: block !important; visibility: visible !important; }
  [data-role="cheque"] [data-role="amountPrefix"] { display: none !important; visibility: hidden !important; }

  [data-role="cheque"] [data-role="inputBox"] {
    display: flex !important;
    flex-direction: row !important;
    visibility: visible !important;
    background: none !important;
    border: none !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 18px !important;
    margin-bottom: 0 !important;
    
    /* Dynamic styling applied here based on state observation */
    margin-left: ${isWrapped ? '28.5cm' : '28.5cm'} !important;
    margin-top: ${isWrapped ? '1.6cm' : '2.2cm'} !important;
  }
}
`, [isWrapped]); // Trigger styles update when isWrapped variable switches boolean states

  return (
    <div data-role="container" style={styles.container}>
      <style>{printCSS}</style>

      {/* Header */}
      <div data-role="header" style={styles.header}>
        <div>
          <h2 data-role="headerTitle" style={styles.headerTitle}>CHEQUE PAYMENTS</h2>
        </div>
        <IoPrintOutline
          data-role="icon"
          style={styles.icon}
          onClick={handlePrint}
          onMouseOver={(e) => (e.currentTarget.style.color = '#34495e')}
          onMouseOut={(e) => (e.currentTarget.style.color = '#2c3e50')}
        />
      </div>

      {/* Cheques */}
      {invoices.map((item, index) => (
        <div key={item.uuid || index} style={styles.chequeWrapper} ref={printRef}>
          <div data-role="cheque" style={styles.cheque}>
            {/* Cheque Number */}
            <div data-role="chequeNumber" style={styles.chequeNumber}>
              {item.teller_number || '4981772420'}
            </div>

            {/* Top Row with Date */}
            <div data-role="topRow" style={styles.topRow}>
              <img src={Ecobank} style={{height: 100, width: 150, objectFit: 'contain'}} alt="Bank Logo"/>
              <div />

              {/* Date Box */}
              <div data-role="dateBox" style={styles.dateBox}>
                {/* Day */}
                <div data-role="section" style={styles.section}>
                  <div data-role="dateLabel" style={styles.dateLabel}>Day</div>
                  {dateDigits.slice(0, 2).map((digit, i) => (
                    <div key={i} data-role="digitBox" style={styles.digitBox}>{digit}</div>
                  ))}
                </div>

                {/* Month */}
                <div data-role="section" style={styles.section}>
                  <div data-role="dateLabel" style={styles.dateLabel}>Month</div>
                  {dateDigits.slice(3, 5).map((digit, i) => (
                    <div key={i + 2} data-role="digitBox" style={styles.digitBox}>{digit}</div>
                  ))}
                </div>

                {/* Year */}
                <div data-role="section" style={styles.section}>
                  <div data-role="dateLabel" style={styles.dateLabel}>Year</div>
                  {dateDigits.slice(6).map((digit, i) => (
                    <div key={i + 4} data-role="digitBox" style={styles.digitBox}>{digit}</div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pay to */}
            <div data-role="payTo" style={styles.payTo}>
              <p data-role="payToLabel" style={styles.payToLabel}>Pay to</p>
              <p data-role="payToValue" style={styles.payToValue}>{item.particular || ''}</p>
            </div>

            {/* The sum of */}
            <div data-role="sumOf" style={styles.sumOf}>
              <p data-role="sumOfLabel" style={styles.sumOfLabel}>The sum of</p>
              <p 
                ref={sumOfLabelValueRef} 
                data-role="sumOfLabelValue" 
                style={styles.sumOfLabelValue}
              >
                {item.total_amount ? toWords.convert(parseFloat(item.total_amount)) : ""}
              </p>
            </div>

            {/* Amount Box */}
            <div data-role="amountBox" style={styles.amountBox}>
              <p data-role="amountPrefix" style={styles.amountPrefix}>{item?.currency?.symbol || '₦'}</p>
              <div data-role="inputBox" style={styles.inputBox}>
                {item.total_amount
                  ? parseFloat(item.total_amount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : "0.00"}
              </div>
            </div>

            {/* Account Details */}
            <div data-role="accountDetails" style={styles.accountDetails}>
              THE&nbsp;REDEEMED&nbsp;CHRISTIAN
              <br />
              CHURCH&nbsp;OF&nbsp;GOD
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}